








import { Component, Vue } from 'vue-property-decorator';
import InvoiceList from '@/components/Invoicing/Invoice/InvoiceList.vue';
import FailedInvoiceDeliveriesWarning from '@/components/Invoicing/Invoice/FailedInvoiceDeliveriesWarning.vue';

@Component({
  components: {
    InvoiceList,
    FailedInvoiceDeliveriesWarning,
  },
})
export default class Invoices extends Vue {}
